<template>
    <GmapMap
            ref="mapRef"
            :center="{lat:this.lat, lng:this.lng}"
            :zoom="zoom"
            map-type-id="terrain"
            :options="{
              scrollwheel: false,
              gestureHandling: 'greedy'
            }"
            style="width: 100%; height: 350px"
    >
        <gmap-polygon :paths="addressArea" ref="polygon" v-if="disableArea" :editable="this.editableArea" @paths_changed="updateEdited($event)"></gmap-polygon>
        <GmapMarker
           ref="marker"
          :position="{lat:this.latMarker, lng:this.lngMarker}"
          :clickable="true"
          :draggable="true"
          :editable="this.editableArea"
          @drag="updateCoordinates"
        />
    </GmapMap>
</template>

<script>
  export default {
    name: "GMDefineArea",
    /*props: ['disableDraggable','defaultArea','defaultLat','defaultLng','editableArea'],*/
    props: {
      disableDraggable: {
        type: Boolean,
        default: false
      },
      defaultArea: {
        default: null
      },
      defaultLat: {
        default: null
      },
      defaultLng: {
        default: null
      },
      defLatMarker: {
        default: null
      },
      defLngMarker: {
        default: null
      },
      zoom: {
        type: Number,
        default: 14
      },
      editableArea: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        addressArea: [],
        drawingManager: null,
        lat: 44.439663,
        lng: 26.096306,
        latMarker: 44.439663,
        lngMarker: 26.096306,
        disableArea: false,
        editable: true,
        myLat: 0,
        myLng: 0
      }
    },
    mounted() {

      this.disableArea = this.disableDraggable;

      if (this.defaultArea) {
        this.addressArea = this.defaultArea;
      }
      if (this.defaultLat) {
        this.lat = parseFloat(this.defaultLat);
      }
      if (this.defaultLng) {
        this.lng = parseFloat(this.defaultLng);
      }
      if (this.defLatMarker) {
        this.latMarker = parseFloat(this.defLatMarker);
      }
      if (this.defLngMarker) {
        this.lngMarker = parseFloat(this.defLngMarker);
      }

      let vm = this;
      this.$eventBus.$on('GO_TO_LOCATION', async function () {
        await vm.startNavigation()
      });
      this.$eventBus.$on('GET_MY_LOCATION', async function () {
        await vm.getMyLocation()
      });

      this.$refs.mapRef.$mapPromise.then((map) => {
        let google = window.google;
        vm.drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.POLYGON,
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ['polygon']
          },
          polygonOptions: {
            editable: true
          }
        });
        vm.drawingManager.setMap(map);
        if (vm.disableArea) {
          vm.drawingManager.setOptions({
            drawingControl: false,
            drawingMode: null
          });
        }
        google.maps.event.addListener(vm.drawingManager, 'polygoncomplete', function (polygon) {
          if (polygon.getPath().getLength() < 3) {
            alert('Aria definita necesita minim 3 puncte alese.');
            polygon.getPath().clear();
            return;
          }
          vm.drawingManager.setOptions({
            drawingControl: false,
            drawingMode: null
          });
          vm.addressArea = [];
          for (let i = 0; i < polygon.getPath().getLength(); i++) {
            let point = polygon.getPath().getAt(i).toUrlValue(6)
            // point = point.replace(',',' ');
            point = point.split(',');
            vm.addressArea.push({lat: parseFloat(point[0]), lng: parseFloat(point[1])});
            // vm.addressArea.push(point);
          }
          // listeners for detecting geometry changes

          google.maps.event.addListener(polygon.getPath(), "insert_at", function (){vm.updatePoints(polygon)});
          google.maps.event.addListener(polygon.getPath(), "set_at", function (){vm.updatePoints(polygon)});
          google.maps.event.addListener(polygon.getPath(), "remove_at", function (){vm.updatePoints(polygon)});
          google.maps.event.addListener(polygon.getPath(), "dragend", function (){vm.updatePoints(polygon)});
          //delete perimeter
          $('#resetPolygon').click(function() {
            if (polygon) {
              polygon.setMap(null);
            }
            vm.drawingManager.setMap(null);
            $('#showonPolygon').hide();
            $('#resetPolygon').hide();
          });
          google.maps.event.addListener(vm.drawingManager, 'polygoncomplete', function() {
            $('#resetPolygon').show();
          });
          $('#enablePolygon').click(function() {
            vm.drawingManager.setMap(map);
            vm.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
          });
        });
      })
    },
    methods: {
      updateCoordinates(location) {
          this.latMarker = location.latLng.lat()
          this.lngMarker = location.latLng.lng()
      },
      updatePoints(polygon) {
        this.addressArea = [];
        for (let i = 0; i < polygon.getPath().getLength(); i++) {
          let point = polygon.getPath().getAt(i).toUrlValue(6)
          //point = point.replace(',',' ');
          point = point.split(',');
          this.addressArea.push({lat: parseFloat(point[0]), lng: parseFloat(point[1])});
        }
      },
      deletePerimter(polygon) {
        polygon.setMap(null);
      },
      updateEdited(mvcArray) {
        let paths = [];
        for (let i=0; i<mvcArray.getLength(); i++) {
          let path = [];
          for (let j=0; j<mvcArray.getAt(i).getLength(); j++) {
            let point = mvcArray.getAt(i).getAt(j);
            path.push({lat: point.lat(), lng: point.lng()});
          }
          paths.push(path);
        }
        this.addressArea = paths[0];
      },
      disableDragable() {
        this.drawingManager.setOptions({
          drawingControl: false,
          drawingMode: null
        });
      },
      async getMyLocation() {
        let vm = this
        await navigator.geolocation.getCurrentPosition((position) => {
          vm.myLat = position.coords.latitude;
          vm.myLng = position.coords.longitude;
          // vm.goToLocation({
          //   lat: position.coords.latitude,
          //   lng: position.coords.longitude
          // })
        });
      },
      goToLocation: function(myLocation) {
        let vm = this
        let directionsService = new window.google.maps.DirectionsService;
        let directionsDisplay = new window.google.maps.DirectionsRenderer;
        directionsDisplay.setMap(this.$refs.mapRef.$mapObject);

        //google maps API's direction service
        function calculateAndDisplayRoute(directionsService, directionsDisplay, start, destination) {
          directionsService.route({
            origin: start,
            destination: destination,
            travelMode: 'DRIVING'
          }, function(response, status) {
            if (status === 'OK') {
              directionsDisplay.setDirections(response);
            } else {
              window.alert('Directions request failed due to ' + status);
            }
          });
        }
        // let start = {
        //   lat: vm.myLat,
        //   lng: vm.myLng
        // }
        let destination = {
          lat: vm.latMarker,
          lng: vm.lngMarker
        }

        let link = `https://www.google.com/maps/dir/Current+Location/${vm.latMarker},${vm.lngMarker}`
        window.open(link,'_black');
        // console.log(start);
        // console.log(destination);
        // console.log('hmmm yha');
        // console.log('https://www.google.com/maps?q=' + encodeURIComponent(destination))
        calculateAndDisplayRoute(directionsService, directionsDisplay, myLocation, destination);
      },

      startNavigation() {
        let link;
        if(this.myLat && this.myLng) {
          link = `https://www.google.com/maps/dir/?api=1&origin=${this.myLat},${this.myLng}&destination=${this.latMarker},${this.lngMarker}`
        } else {
          link = `https://www.google.com/maps/dir/Current+Location/${this.latMarker},${this.lngMarker}`
        }
        // console.log(link);
        window.open(link,'_black');
      }
    }
  }
</script>

<style scoped>

</style>
